import { Component,inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTableComponent } from '@tamilarasitech/shared-ui-components';
import { TableService } from '../../components/shared/table.service';

@Component({
  selector: 'app-listing',
  standalone: true,
  imports: [CommonModule, SharedTableComponent],
  template:  `
    <tt-shared-table
      #sharedTable
      [name]="'listing'"
      (loadPage)="tableService.onLoadPage($event, sharedTable)"
      (getTotal)="tableService.onGetTotal($event, sharedTable)"
      (add)="tableService.onAdd($event)"
      (update)="tableService.onUpdate($event)"
      (delete)="tableService.onDelete($event)"
      (deleteBatch)="tableService.onDeleteBatch($event)"
      (deleteAllEmit)="tableService.onDeleteAll()"
      (uploadFile)="tableService.onUploadFile($event)"
      (importData)="tableService.onImportData($event)"
    ></tt-shared-table>
  `
})
export class ListingComponent {
    tableService = inject(TableService);

}